<template>
    <div>
        <div>
            <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar">
                {{callbackResponse.message}}
                <v-btn @click="snackbar = false" dark text>Close</v-btn>
            </v-snackbar>
            <v-form>
                <v-row>
                    <v-card class="pa-4 mx-3" id="form_card" width="100%">
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row>
                                    <v-col>
                                        <v-autocomplete :error-messages="yearErrors"
                                                        :items="yearList"
                                                        @input="setValueYear(logData.year)"
                                                        item-text="id" dense outlined
                                                        item-value="value"
                                                        :label="$t('select_year')"
                                                        required
                                                        v-model="logData.year">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col>
                                        <v-btn @click="reportLog(logData)" color="green" dark>
                                            {{$t('search')}}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-card>
                </v-row>
            </v-form>
        </div>
        <br />
        <v-dialog fullscreen v-model="dialogApproved">


            <ApprovedComponent :key="count" :approvebtnData="approveData" @formResponse="onResponse"></ApprovedComponent>
        </v-dialog>

        <v-expansion-panels class="my-8" hover v-if="loglist.rows.length>0" v-model="panelData">

            <v-expansion-panel>
                <v-expansion-panel-header>Report Logs</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-container fluid>
                        <vue-good-table :columns="loglist.columns"
                                        :pagination-options="{ enabled: true, perPageDropdown: [15, 50, 100],}"
                                        :rows="loglist.rows" :row-style-class="rowStyleClassFn"
                                        :totalRows="loglist.totalRecords"
                                        @on-column-filter="onColumnFilter"
                                        @on-page-change="onPageChange"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        theme="black-rhino">
                            <template slot="table-column" slot-scope="props">
                                <span>
                                    {{ $t(props.column.label) }}
                                </span>
                            </template>
                            <!--            added action column in vue good table-->
                            <template slot="table-row" slot-scope="props">

                                <span v-if="props.column.field == 'actions' ">
                                    <v-btn @click="logBtnData(props.row,false,props.row.year)"
                                           color="primary">{{$t('view')}} </v-btn>
                                </span>
                                <span v-else-if="props.column.field == 'approved' && !props.row.isWrongData  ">
                                    <span v-if="props.row.isFinalized">
                                        <v-btn @click="approvebtnData(props.row)"
                                               color="success">{{$t('view')}}</v-btn>
                                    </span>
                                    <span v-else>
                                        
                                        {{$t('pending_approval')}}
                                    </span>
                                </span>

                                <span v-else-if="props.column.field == 'comparison' ">

                                    <span v-if="props.row.isFinalized">
                                        <v-btn @click="comparedata(props.row)"
                                               color="danger">{{$t('comparison')}}   </v-btn>
                                    </span>
                                    <span v-else>
                                    </span>


                                    
                                </span>
                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>
                            </template>

                        </vue-good-table>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-dialog v-model="formModal"
                  max-width="800"
                  transition="dialog-bottom-transition"
                  persistent>
            <v-card>
                <v-card>
                    <v-toolbar class="toolbar-header-color">
                        <v-toolbar-title>
                            {{$t('compare')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialogueClose">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <vue-good-table :columns="comparitionData.columns"
                                            :rows="comparitionData.rows" :row-style-class="rowStyleClassFn"
                                            :totalRows="comparitionData.totalRecords"
                                            theme="black-rhino">
                                <template slot="table-column" slot-scope="props">
                                    <span>
                                        {{ $t(props.column.label) }}
                                    </span>
                                </template>
                            </vue-good-table>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
              
            </v-card>
        </v-dialog>

        <div v-if="table && headers.length>0">


            <!--<span v-if="isLoadedFromServer">Saving...</span>
    <v-btn v-else @click="updateReportData" class="float-right mt-10" color="success" style="margin-bottom:10px">
        Save
    </v-btn>-->
            <v-btn @click="exportTableToExcel('tblData','('+reportTitle+'_'+valueShow+')',showNextYear?YearPreviousCurrentNext.next:yearShow)" dark class="float-right mt-10 mr-2" color="blue darken-4" style="margin-bottom:10px">
                Export
            </v-btn>
          
            <h2 style="text-align:center">{{valueShow}} आ.ब.{{showNextYear?YearPreviousCurrentNext.next:yearShow}} को {{reportTitle}}</h2>
            <table class="table tbl sticky-table-header">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                     आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                     आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                     आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                     आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--NEW-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">

                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">
                               
                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                     आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END-->

                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                   आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>


                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>
                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>

                <template v-for="(section,index) in rows">
                    <tr :key="'row1mk'+index">
                        <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                            <span> {{index+1}}. {{section.reportSection}}</span>
                        </td>
                    </tr>
                    <template v-for="(subSection,properindex) in section.list">
                        <tr :key="properindex+'row2lk'+index">
                            <td style="text-align:center">{{index+1}}</td>
                            <td style="text-align:center">{{subSection.reportSubSection}}</td>
                            <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                v-for="(rowsHeader, subindex) in subSection.list">
                                <v-text-field dense @keypress="isNumber($event)" label="Amount" outlined
                                              v-if="rowsHeader.dataType==2" v-model="rowsHeader.amount"
                                              v-on:input="calculateTotal()" readonly></v-text-field>
                                <v-text-field dense @keypress="isNumber($event)" label="Quantity" outlined
                                              v-else-if="rowsHeader.dataType==4" v-model="rowsHeader.amount"
                                              v-on:input="calculateTotal()" readonly></v-text-field>
                                <v-text-field dense @keypress="isNumber($event)" label="Quantity 1" outlined
                                              v-else-if="rowsHeader.dataType==6" v-model="rowsHeader.amount"
                                              v-on:input="calculateTotal()"></v-text-field>
                                <v-text-field dense @keypress="isNumber($event)" label="Total" outlined
                                              v-else-if="rowsHeader.dataType==5"
                                              v-model="rowsHeader.amount" readonly></v-text-field>
                                <v-text-field dense label="Text" outlined v-else v-model="rowsHeader.value" readonly></v-text-field>
                            </td>
                        </tr>
                    </template>
                </template>
                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>



            <table class="table tbl" id="tblData" v-show="exportTbl">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                              आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                             आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                     आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                     आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                     आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                     आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                               आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                             आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                             आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                 आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                   आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>
                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>

                <template v-for="(section,index) in rows">
                    <tr :key="'row1mk'+index">
                        <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                            <span> {{index+1}}. {{section.reportSection}}</span>
                        </td>
                    </tr>
                    <template v-for="(subSection,properindex) in section.list">
                        <tr :key="properindex+'row2lk'+index">
                            <td style="text-align:center">{{index+1}}</td>
                            <td style="text-align:center">{{subSection.reportSubSection}}</td>
                            <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                v-for="(rowsHeader, subindex) in subSection.list">
                                <v-span v-if="rowsHeader.dataType==2">{{rowsHeader.amount}}</v-span>
                                <v-span label="Quantity" outlined
                                        v-else-if="rowsHeader.dataType==4">{{rowsHeader.amount}}</v-span>
                                <v-span label="Quantity1" outlined
                                        v-else-if="rowsHeader.dataType==6">{{rowsHeader.amount}}</v-span>
                                <v-span label="Total" outlined
                                        v-else-if="rowsHeader.dataType==5">{{rowsHeader.amount}}</v-span>
                                <v-span label="Text" outlined v-else>{{rowsHeader.value}}</v-span>
                            </td>
                        </tr>
                    </template>
                </template>
                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div v-if="tableView && headers.length>0">

            <h2 style="text-align:center">{{valueShow}} आ.ब.{{showNextYear?YearPreviousCurrentNext.next:yearShow}} को {{reportTitle}}</h2>
            <table class="table tbl">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                      आ.ब.  {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                              आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                              आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->


                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->


                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">
                               
                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                       आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                             आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                               आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>

                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                   आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                     आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>


                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>


                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>
            <table class="table tbl" id="tblData" v-show="exportTbl">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                       आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                       आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                              आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                       आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>


                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END-->

                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>

                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                              आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                   आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                   आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                  आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->
                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                       आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                      आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>

                                    <!--END NEW-->

                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                       आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                       आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                       आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>


                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";
    // import router from "@/routes/router";
    import ApprovedComponent from "./ApprovedComponent";
    import { mapGetters } from "vuex";
    //import CompareForm from "./CompareForm";
    export default {
        name: 'ReportComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            isBranch() {
                return this.userRole === "Branch"
            },
            isDepo() {
                return this.userRole === "Depo"
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                    errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                    errors.push("Year is required.");
                return errors;
            },
        },
        props: ['ApiData'],
        components: {
            ApprovedComponent,
            //CompareForm
        },
        data() {
            return {
                count: 1,
                exportTbl: false,
                dialogApproved: false,
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                // currentYear: new Date().getFullYear(),
                loglist: {
                    rows: [],
                    selectedData: "",
                    totalRecords: 2,
                    columns: [
                        {
                            label: 'reportID',
                            field: 'reportID'
                        },
                        {
                            label: 'reportLogID',
                            field: 'reportLogID'
                        },
                        {
                            label: 'company',
                            field: 'companyName'
                        },
                        {
                            label: 'branch',
                            field: 'branchName'
                        },
                        {
                            label: 'depo',
                            field: 'depoName'
                        },
                        {
                            label: 'department',
                            field: 'departmentName'
                        },

                        {
                            label: 'year',
                            field: 'yearName'
                        },
                        {
                            label: 'approved',
                            field: 'approved'
                        },
                        {
                            label: 'comparison',
                            field: 'comparison'
                        },
                        {
                            label: 'actions',
                            field: 'actions'
                        },

                    ]
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                snackbar: false,
                table: false,
                dialogCreate: false,
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                showNextYear: false,
                yearList: [],
                tableFormData: [],
                helpData: [],
                approveData: [],
                logData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                yearShow: "",
                valueShow: "",
                setYearValue: "",
                setAllValue: "",
                submitStatus: "",
                YearPreviousCurrentNext: {},
                groupedRows: [],
                color: "",
                isLoadedFromServer: false,
                formModal: false,
                createFormComponent: false,
                comparitionData: {
                    rows: [],
                    selectedData: "",
                    columns: [
                        {
                            label: 'subSectionName',
                            field: 'subSectionName'
                        },
                        {
                            label: 'title',
                            field: 'title'
                        },
                        {
                            label: 'subTitle',
                            field: 'subTitle'
                        },
                        {
                            label: 'headerName',
                            field: 'headerName'
                        },
                        {
                            label: 'original',
                            field: 'originalAmount'
                        },
                        {
                            label: 'approval',
                            field: 'approvalAmount'
                        },




                    ]
                },

            };
        },
        validations: {
            logData: {
                companyID: { required },
                year: { required },
            }
        },
        mounted() {
            this.loadCrumb()
            this.reportLog()
            this.$root.$on('formResponse', data => {
                if (data.updated == true) {
                    this.getColsRow(this.logData)
                }
            });
        },

        methods: {
            onResponse(data) {
                if (data) {
                    this.dialogApproved = false
                }
            },
            comparedata(row) {
                this.formModal = true
                this.createFormComponent = true
                this.approveData = {
                    reportLogID: parseInt(row.reportLogID),
                    reportID: row.reportID,
                    year: row.year
                };
                axios.post("ReportSettings/ReportWithApprovalData", this.approveData).then(response => {
                    this.comparitionData.rows = response.data;

                }).catch(function (error) {
                    console.log(error);
                    this.status = "danger"
                    this.color = "danger"
                    this.snackbar = true
                    this.callbackResponse.message = "Internal server error."
                    this.isLoadedFromServer = false;
                });

            },
            dialogueClose() {
                this.formModal = false
                this.createFormComponent = false
            },
            getDdlData(data, val) {

                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.branchID = 0
                    this.logData.depoID = 0
                    this.logData.departmentID = 0
                    formVal = {
                        companyID: this.logData.companyID
                    }
                    axios.get("Branch/DDLBranchList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.depoID = ""
                    this.logData.departmentID = 0

                    formVal = {
                        branchID: this.logData.branchID
                    }
                    axios.get("Depo/DDLDepoList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.logData.departmentID = 0

                    formVal = {
                        depoID: this.logData.depoID
                    }
                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },

            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            setValue(data, type) {
                if (type == "Company") {
                    this.logData.departmentID = "";
                    this.logData.branchID = "";
                }
                if (type == "Department") {
                    this.logData.branchID = "";
                }
                if (type == "Branch") {
                    this.departmentSelectedCompany('depo')
                    this.logData.departmentID = "";
                    this.selectedStatus.branch = ""
                }
            },

            setValueYear(data) {
                var year = this.yearList.filter(function (item) {
                    return item.value === data;
                });
                this.setYearValue = year[0].id;
            },

            departmentSelectedCompany(val) {
                let logData = {}
                if (val == "company") {
                    this.logData.branchID = ""
                    this.selectedStatus.branch = ""
                    this.logData.depoID = ""
                    logData = {
                        companyID: this.logData.companyID
                    }
                } else if (val == "branch") {
                    logData = {
                        branchID: this.logData.branchID
                    }
                } else if (val == "depo") {
                    logData = {
                        depoID: this.logData.depoID
                    }
                }
                axios.post('Department/DDLDepartmentList', logData).then(response => {
                    this.listDDLData.departmentList = response.data
                })
            },

            checkLogs(data) {
                if (data.departmentID > 0) {
                    let departmentYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.departmentID === data.departmentID;
                    });
                    if (departmentYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (data.depoID > 0) {
                    let depoYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.depoID === data.depoID;
                    });
                    if (depoYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (data.branchID > 0) {
                    let branchYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.branchID === data.branchID;
                    });
                    if (branchYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    let companyYear = this.loglist.rows.filter(function (item) {
                        return item.year === data.year && item.companyID === data.companyID && item.departmentID == null && item.branchID == null;
                    });
                    if (companyYear.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            ViewStructureupdateData(data, checkLogStatus) {
                data.companyID = data.companyID == null ? 1 : data.companyID

                let companyID = data.companyID ? parseInt(data.companyID) : ""
                if (checkLogStatus) {
                    let serverData = {
                        ReportID: parseInt(data.reportID),
                        CompanyID: parseInt(companyID),
                        BranchID: parseInt(data.branchID),
                        DepoID: parseInt(data.depoID),
                        DepartmentID: parseInt(data.departmentID),
                        Year: data.year
                    };
                    console.log(serverData);
                    axios.post("ReportSettings/CheckLogAsync", serverData).then(response => {
                        console.log(response)
                        if (response.data.existed) {
                            //this.status = "warning"
                            //this.snackbar = true
                            //this.color = "warning"
                            //this.callbackResponse.message = response.data.message;
                            return false;
                        }
                        else {
                            this.logData.reportLogID = 0;
                            this.logData.branchID = parseInt(data.branchID);
                            this.logData.companyID = companyID;
                            this.logData.departmentID = parseInt(data.departmentID);
                            this.logData.depoID = parseInt(data.depoID);
                        }
                    })

                } else {
                    this.logData.reportLogID = parseInt(data.reportLogID);
                    this.logData.branchID = parseInt(data.branchID);
                    this.logData.companyID = companyID;
                    this.logData.departmentID = parseInt(data.departmentID);
                    this.logData.depoID = parseInt(data.depoID);
                }
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    this.yearShow = this.setYearValue;
                    this.valueShow = this.setAllValue;
                    this.table = false;
                    this.tableView = true;
                    this.logData.year = data.year;
                    this.serverData = this.logData;
                    this.getColsRow(this.serverData)
                }
            },

            updateData(data, checkLogStatus) {
                data.companyID = data.companyID == null ? 1 : data.companyID
                let companyID = data.companyID ? parseInt(data.companyID) : ""
                if (checkLogStatus) {
                    let serverData = {
                        ReportID: parseInt(data.reportID),
                        CompanyID: parseInt(companyID),
                        BranchID: parseInt(data.branchID),
                        DepoID: parseInt(data.depoID),
                        DepartmentID: parseInt(data.departmentID),
                        Year: data.year
                    };
                    console.log(serverData);
                    axios.post("ReportSettings/CheckLogAsync", serverData).then(response => {
                        console.log(response)
                        if (response.data.existed) {
                            this.status = "warning"
                            this.snackbar = true
                            this.color = "warning"
                            this.callbackResponse.message = response.data.message;
                            return false;
                        }
                        else {
                            this.logData.reportLogID = 0;
                            this.logData.branchID = parseInt(data.branchID);
                            this.logData.companyID = companyID;
                            this.logData.departmentID = parseInt(data.departmentID);
                            this.logData.depoID = parseInt(data.depoID);
                        }
                    })

                } else {
                    this.logData.reportLogID = parseInt(data.reportLogID);
                    this.logData.branchID = parseInt(data.branchID);
                    this.logData.companyID = companyID;
                    this.logData.departmentID = parseInt(data.departmentID);
                    this.logData.depoID = parseInt(data.depoID);
                }
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    this.yearShow = this.setYearValue;
                    this.valueShow = this.setAllValue;
                    this.table = true;
                    this.tableView = false;
                    this.logData.year = data.year
                    this.serverData = this.logData;
                    this.getColsRow(this.serverData)
                }
            },

            reset() {
                let reportID = this.logData.reportID;
                this.logData = {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: reportID,
                    year: "",
                    reportLogID: 0
                },
                    this.status = {
                        isCompany: false,
                        isDepartment: false,
                    }
                this.selectedStatus = {
                    company: "",
                    branch: ""
                }
                this.$nextTick(() => {
                    this.$v.$reset()
                })
            },

            logBtnData(row, status, year) {
                this.logData.companyID = row.companyID
                this.logData.reportLogID = row.reportLogID
                this.helpData = row
                if (this.logData.companyID) {
                    this.getDdlData(this.logData.companyID, 'company');
                    this.logData.branchID = this.helpData.branchID
                    if (this.logData.branchID) {
                        this.getDdlData(this.logData.branchID, 'branch')
                        this.logData.depoID = this.helpData.depoID
                        if (this.logData.depoID) {
                            this.getDdlData(this.logData.depoID, 'depo')
                        }
                    }
                }

                this.logData.departmentID = this.helpData.departmentID
                this.logData.year = year
                if (row.departmentID > 0) {
                    this.valueShow = row.departmentName
                } else if (row.depoID > 0) {
                    this.valueShow = row.depoName
                } else if (row.branchID > 0) {
                    this.valueShow = row.branchName
                } else {
                    this.valueShow = row.companyName
                }
                this.yearShow = row.yearName
                var data = {
                    "reportLogID": parseInt(row.reportLogID),
                    "year": year,
                    "departmentID": parseInt(row.departmentID),
                    "depoID": parseInt(row.depoID),
                    "branchID": parseInt(row.branchID),
                    "companyID": parseInt(row.companyID),
                    "reportID": row.reportID
                }
                this.serverData = data;
                this.table = true
                this.getColsRow(this.serverData)
            },
            updateWrongData(row) {
                let model = {
                    ReportID: row.reportID,
                    IsWrongData: row.isWrongData,
                    ReportLogID: row.reportLogID
                }
                axios.post("ReportSettings/WrongDataUpdateAsync", model).then(response => {
                    console.log(response)
                    if (response.data.success) {
                        this.status = "success"
                        this.snackbar = true
                        this.color = "success"
                        this.callbackResponse.message = "Successfully updated.";
                        this.reportLog();
                    }
                })
            },

            getColsRow(data) {
                const currentYearIndex = this.indexWhere(this.yearList, item => item.value === data.year)
                let previousThreeYearIndex = currentYearIndex - 3;
                let previousTwoYearIndex = currentYearIndex - 2;
                let previousYearIndex = currentYearIndex - 1;
                let nextYearIndex = currentYearIndex + 1;
                let previousCurrentNext = {};
                this.yearList.forEach(function (data, yearIndex) {
                    if (currentYearIndex == yearIndex) {
                        previousCurrentNext.current = data.id
                    }
                    //NEW
                    if (previousTwoYearIndex == yearIndex) {
                        previousCurrentNext.twoYear = data.id
                    }
                    if (previousThreeYearIndex == yearIndex) {
                        previousCurrentNext.threeYear = data.id
                    }
                    //end NEW
                    if (previousYearIndex == yearIndex) {
                        previousCurrentNext.previous = data.id
                    }
                    if (nextYearIndex == yearIndex) {
                        previousCurrentNext.next = data.id
                    }
                })
                if (data.depoID == "") {
                    data.depoID = null
                }
                this.YearPreviousCurrentNext = previousCurrentNext;
                axios.post('ReportSettings/GetColsRows', data).then(response => {
                    this.rows = response.data.rows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                    this.showNextYear = response.data.showNextYear;
                })
            },

            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },

            reportLog(Details) {
                this.$nextTick(() => {
                    this.$v.$reset()
                })

                if (Details == undefined) {
                    let departmentID = 0;

                    this.serverParams.reportID = this.logData.reportID
                    this.serverParams.companyID = this.logData.companyID
                    this.serverParams.departmentID = departmentID
                    this.serverParams.branchID = this.logData.branchID
                    this.serverParams.year = "2076"
                    this.serverParams.depoID = this.logData.depoID
                } else {
                    let branchID = 0;
                    let companyID = 0;
                    let departmentID = 0;
                    let depoID = 0;
                    if (Details.companyID != "" && Details.companyID != undefined) {
                        companyID = parseInt(Details.companyID)
                    }
                    if (Details.departmentID != "" && Details.departmentID != undefined) {
                        departmentID = parseInt(Details.departmentID)
                    }
                    if (Details.branchID != "" && Details.branchID != undefined) {
                        branchID = parseInt(Details.branchID)
                    }
                    if (Details.depoID != "" && Details.depoID != undefined) {
                        depoID = parseInt(Details.depoID)
                    }

                    this.serverParams.reportID = parseInt(this.logData.reportID)
                    this.serverParams.companyID = parseInt(companyID)
                    this.serverParams.departmentID = parseInt(departmentID)
                    this.serverParams.branchID = parseInt(branchID)
                    this.serverParams.year = Details.year
                    this.serverParams.depoID = parseInt(depoID)
                }
                let param = {
                    reportID: this.serverParams.reportID,
                    companyID: this.serverParams.companyID,
                    departmentID: this.serverParams.departmentID,
                    branchID: this.serverParams.branchID,
                    depoID: this.serverParams.depoID,
                    year: this.serverParams.year,
                    PageSize: this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field
                };

                axios.post("ReportSettings/GetReportLogs", param).then(response => {
                    this.loglist.rows = response.data.data
                    this.loglist.totalRecords = response.data.totalCount
                })
            },

            loadCrumb() {
                if (this.role == "Company") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                }
                else if (this.role == "Branch") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                    this.logData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.logData.branchID, 'branch')
                }
                else if (this.role == "Depo") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                    this.logData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.logData.branchID, 'branch')
                    this.logData.depoID = parseInt(this.userData.depoID)
                    this.getDdlData(this.logData.branchID, 'depo')
                }
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })

                axios.get('ReportSettings/DDLReportList').then(response => {
                    this.reportList = response.data
                })

                axios.get('Company/DDLCompanyList').then(response => {
                    this.listDDLData.companyList = response.data
                })

                this.breadCrumbs = [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: `${this.userData.dashBoardBranchUser}`,
                        exact: true
                    },
                    {
                        text: 'Profile',
                        disabled: true,
                    },
                ]
            },

            nullTitle(title) {
                return title == null
            },

            approvebtnData(row) {
                this.dialogApproved = true
                this.count++
                this.approveData = {
                    reportLogID: parseInt(row.reportLogID),
                    reportID: row.reportID,
                    year: row.year
                }
            },

            branchData() {
                axios.get("Branch/DDLBranchList", {
                    params: {
                        companyID: this.logData.companyID
                    }
                }).then(response => {
                    this.listDDLData.branchList = response.data
                })
            },

            depoData() {
                this.listDDLData.depoList = []
                axios.get("Depo/DDLDepoList", {
                    params: {
                        branchID: this.logData.branchID
                    }
                }).then(response => {
                    this.listDDLData.depoList = response.data
                })
            },

            updateReportData() {
                this.isLoadedFromServer = true;
                var tableFormData = [];
                this.rows.forEach(function (data) {
                    data.list.forEach(function (list) {
                        list.list.forEach(function (amount) {
                            //    if (parseFloat(amount.amount) > 0 || (amount.value != "")) {
                            amount.amount = parseFloat(amount.amount);
                            tableFormData.push(amount);
                            //   }
                        })
                    })
                })
                let logData = {
                    "companyID": this.serverData.companyID,
                    "departmentID": this.serverData.departmentID,
                    "branchID": this.serverData.branchID,
                    "depoID": this.serverData.depoID,
                    "reportID": parseInt(this.serverData.reportID),
                    "year": this.serverData.year,
                    "list": tableFormData,
                    "reportLogID": this.serverData.reportLogID == "" ? 0 : parseInt(this.serverData.reportLogID)
                }
                axios.post("ReportSettings/InsertOrUpdateReportDataAsync", logData).then(response => {
                    if (response.data.success) {
                        this.logData.reportLogID = response.data.id;
                        this.status = "success"
                        this.color = "success"
                        this.snackbar = true
                        this.callbackResponse.message = "Data updated successfully."
                        this.reportLog()
                        this.isLoadedFromServer = false;
                    }
                }).catch(function (error) {
                    console.log(error);
                    this.status = "danger"
                    this.color = "danger"
                    this.snackbar = true
                    this.callbackResponse.message = "Internal server error."
                    this.isLoadedFromServer = false;
                })
            },
            calculateTotal: function () {
                // totals and footer totals
                let AllRows = [];
                this.rows.forEach(function (section) {
                    section.list.forEach(function (subsection) {

                        subsection.list.forEach(function (amount) {
                            let amountToCal = 0;
                            var matchedData = subsection.list.filter(function (data) {
                                return (data.titleID == amount.titleID && data.subTitleID == amount.subTitleID)
                            });
                            if (matchedData.length > 0) {
                                let AmountList = matchedData.filter(function (data) {
                                    return (data.dataType == 2);
                                });

                                //if TotalToAdd Existed
                                let AmountAddToTotalList = matchedData.filter(function (data) {
                                    return (data.dataType == 2 && data.addToTotal == true);
                                });
                                if (AmountAddToTotalList.length > 0) {
                                    amountToCal = AmountAddToTotalList.reduce((acc, item) => acc + parseFloat(item.amount), 0);
                                    //must have Total column selected and AddTotal
                                    if (amount.dataType == 5 && amount.addTotal == true) {
                                        amount.amount = amountToCal.toFixed(2);
                                    }
                                }
                                //if TotalToAdd Existed

                                else {
                                    //Totals
                                    if (AmountList.length > 0) {
                                        amountToCal = AmountList.reduce((acc, item) => acc + parseFloat(item.amount), 0);
                                        if (amount.dataType == 5) {
                                            let Quantity = matchedData.find(x => x.dataType === 4);
                                            let Quantity1 = matchedData.find(x => x.dataType === 6);

                                            amount.amount = 0;
                                            if (Quantity != undefined) {
                                                if (parseFloat(Quantity.amount) > 0) {
                                                    amount.amount = parseFloat(Quantity.amount) * amountToCal;
                                                    if (Quantity1 != undefined) {
                                                        if (parseFloat(Quantity1.amount) > 0) {
                                                            amount.amount = parseFloat(Quantity1.amount) * amount.amount;
                                                        } else {
                                                            amount.amount;
                                                        }
                                                    } else {
                                                        amount.amount;
                                                    }
                                                } else {
                                                    amount.amount = amountToCal;
                                                }
                                            } else {
                                                amount.amount = amountToCal;
                                            }


                                            amount.amount = amount.amount.toFixed(2);
                                        }
                                    }
                                }

                                if (parseFloat(amount.amount) > 0) {
                                    AllRows.push(
                                        {
                                            "reportHeaderID": amount.reportHeaderID,
                                            "amount": parseFloat(amount.amount),
                                            "section": amount.reportSection
                                        });
                                }
                            }

                        })
                    })
                })
                this.totals.forEach(function (data) {
                    data.total = 0;
                    let Total = 0;
                    var match = AllRows.filter(function (item) {
                        return item.reportHeaderID === data.headerID;
                    }).reduce((total, amount) => {
                        return total + parseFloat(amount.amount)
                    }, 0);




                    var Expenses = AllRows.filter(function (item) {
                        return item.reportHeaderID === data.headerID && item.section.trim() == 'खर्छ तर्फ';
                    }).reduce((total, amount) => {
                        return total + parseFloat(amount.amount)
                    }, 0);

                    var Profit = AllRows.filter(function (item) {
                        return item.reportHeaderID === data.headerID && item.section.trim() == 'आय तर्फ';
                    }).reduce((total, amount) => {
                        return total + parseFloat(amount.amount)
                    }, 0);
                    if (Profit > 0 || Expenses > 0) {
                        Total = (parseFloat(Profit) - parseFloat(Expenses));
                    }
                    else {
                        Total = match;
                    }
                    data.total = parseFloat(Total);
                    data.total = data.total.toFixed(2);
                })
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.reportLog();
            },

            onPerPageChange(params) {
                this.serverParams.page = 1
                this.updateParams({ perPage: params.currentPerPage });
                this.reportLog();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.reportLog();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.reportLog();
            },

            exportTableToExcel(tableID, filename = '', year) {
                var downloadLink;
                var dataType = 'application/vnd.ms-excel';
                var tableSelect = document.getElementById(tableID);
                var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

                // Specify file name
                filename = filename ? filename + year + '.xls' : 'reportForm.xls';

                // Create download link element
                downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);

                if (navigator.msSaveOrOpenBlob) {
                    var blob = new Blob(['\ufeff', tableHTML], {
                        type: dataType
                    });
                    navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // Create a link to the file
                    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                    // Setting the file name
                    downloadLink.download = filename;

                    //triggering the function
                    downloadLink.click();
                }
            },

            rowStyleClassFn(row) {
                return row.isWrongData == true ? "red lighten-3" : "";
            }

        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl {

        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: $main-color;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;

    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .data-input {
        .v-input {
            max-width: 7.1em !important;
        }
    }

    input {
        max-width: 5.7em !important;
    }

    .employee-form-header {
        text-align: center;
        background-color: $main-color;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }

    #form_card {
        text-align: center;

    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }
.sticky-table-header{
  thead{
    position: sticky;
    top: 60px;
    z-index: 1;
  }
}
</style>
